import { render } from "./discount-create-import.vue?vue&type=template&id=24c92fe6"
import script from "./discount-create-import.vue?vue&type=script&lang=js"
export * from "./discount-create-import.vue?vue&type=script&lang=js"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__